import type { FaireProductEntity } from "../../entity_types/product";

export const p_6frcenrwk7: FaireProductEntity = {
  token: "p_6frcenrwk7",
  type: "product",
  name: "Play Ball Charms",
  brandToken: "b_m8tfhuqt3u",
  brandName: "Kickin it up Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/3e3df753f060526fbaf0c9cc5f60d559b579d5eb733c1dfea7bb898e0e45bb57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/683145f1f9248509b9f92817ad23a5a2bf83586da0a161075969eb6450add8e4.jpeg",
    "https://cdn.faire.com/fastly/9ecf39967711c8aa3d09016802ca4dcf370fae414280fb4c6e13b3d688fc1826.jpeg",
    "https://cdn.faire.com/fastly/f89a1508303529190caa375e64183ccd5007f01db04207f2562d7b026c50294b.jpeg",
    "https://cdn.faire.com/fastly/0dada85cf063bae8a124662d014a1dee4f4f076ac5efd8f00269854211a11cdb.jpeg",
    "https://cdn.faire.com/fastly/e025beb973e19dce7222aa40c0b3112796f59a99f57f3a880a434a6b842d6ed1.jpeg",
    "https://cdn.faire.com/fastly/b1a83a4a18cf0a0b71dc038a9cac32e313edc564e159e5d2a0c5aa66e81cc503.jpeg",
    "https://cdn.faire.com/fastly/3e58426377e35268416b82571a50f8509782b2924895474574d8be79588d5726.jpeg",
    "https://cdn.faire.com/fastly/a5917e013355973bdcfe9c43b47512db59aff4dc9872daee34e3733fc829f6fa.jpeg",
    "https://cdn.faire.com/fastly/9136848a557e9e9ad28a9feacc8a38278129b0df9656200696876dcd9441fde0.jpeg",
  ],
  priceDollars: 12,
  description:
    "\nOur Play Ball Charms are perfect for your little slugger to sport on and off the field making them out of this league!\n\n** CHARMS HAVE SMALL PARTS THAT COULD BE CHOKING HAZARDS FOR CHILDREN UNDER THE AGE OF THREE YEARS OLD AND/OR OLDER. PARENT SUPERVISION IS RECOMMENDED.** \n",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:27.073Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
